/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Response } from '../../models/response';

export interface ApiOrderOrdersOrderIdCheckstatusPut$Plain$Params {
  orderId: string;
}

export function apiOrderOrdersOrderIdCheckstatusPut$Plain(http: HttpClient, rootUrl: string, params: ApiOrderOrdersOrderIdCheckstatusPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
  const rb = new RequestBuilder(rootUrl, apiOrderOrdersOrderIdCheckstatusPut$Plain.PATH, 'put');
  if (params) {
    rb.path('orderId', params.orderId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Response>;
    })
  );
}

apiOrderOrdersOrderIdCheckstatusPut$Plain.PATH = '/api/order/orders/{orderId}/checkstatus';
